const namespace = window.VelotricBundle
if (!namespace?.["shell"]?.ready) { throw new Error("vl-bundle-shell.js must execute before vl-bundle-product.js") }
const sharedApi = namespace["shell"].api
if (!sharedApi) { throw new Error("Missing shell named API contract") }
export const BaseComponent = sharedApi["BaseComponent"]
export const ShopifyEditor = sharedApi["ShopifyEditor"]